/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import * as R from 'ramda';
import { takeLatest, put, select } from 'redux-saga/effects';
import { selectEnabledViewPlugins, selectSessionRouteParam, selectSessionSettings } from '../../common/selectors';
import { watchShellSettingsChanges } from '../data/prefabs';
import {
  CONFIGURE_VIEW_PLUGINS,
  APPLY_VIEW_PLUGINS
} from '../actions';
import {
  writeViewPluginToOrg,
  writeViewPluginToUser,
  writeSessionSettingsToSession
} from '../../common/actions';

export function* doConfigure({ payload }) {
  const sessionId = yield select(selectSessionRouteParam);
  const sessionSettings = yield select(selectSessionSettings);

  yield put(watchShellSettingsChanges.turnOnAction);
  yield put(writeSessionSettingsToSession(
    R.assocPath([sessionId, 'enabledViewPlugins'], payload, sessionSettings)
  ));
}

export function* doApply({ payload: mode }) {
  const data = yield select(selectEnabledViewPlugins);
  const action = mode === 'org' ? writeViewPluginToOrg : writeViewPluginToUser;
  yield put(action(R.pluck('namespace', data)));
}

export function* watchConfigureViewPluginsSaga() {
  yield takeLatest(CONFIGURE_VIEW_PLUGINS, doConfigure);
}

export function* watchApplyViewPluginsSaga() {
  yield takeLatest(APPLY_VIEW_PLUGINS, doApply);
}
